export const constants = {
  BASE_WIDTH: 50,
  BASE_HEIGHT: 20,
  GROUND_HEIGHT: 150,
  DISK_COLORS: [
    "#448098",
    "#e2c1b9",
    "#da344d",
    "#d7bc3e",
    "#2faa77",
    "#e37e8c",
    // "#57a9d4",
    // "#a08986"
  ]
};
